import { render } from "./RoundTimer.vue?vue&type=template&id=4df84e11&ts=true"
import script from "./RoundTimer.vue?vue&type=script&lang=ts"
export * from "./RoundTimer.vue?vue&type=script&lang=ts"

import "./RoundTimer.vue?vue&type=style&index=0&id=4df84e11&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__